import { render, staticRenderFns } from "./sample-order.vue?vue&type=template&id=7c1cd964&scoped=true"
import script from "./sample-order.vue?vue&type=script&lang=js"
export * from "./sample-order.vue?vue&type=script&lang=js"
import style0 from "./sample-order.vue?vue&type=style&index=0&id=7c1cd964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1cd964",
  null
  
)

export default component.exports